import React, { useState } from 'react'
import usersFilterContext from '../../contexts/users-filter'
import currentGradYear from '../../utilities/current-grad-year'

const UsersFilterProvider = ({
    children,
    limit = 18,
    rolesCode = 's',
    gradYearMinimum = currentGradYear,
    gradYearMaximum = currentGradYear + 4
}) => {
    const [ filters, setFilters ] = useState({
        limit,
        rolesCode,
        gradYearMinimum,
        gradYearMaximum
    })
    return (
        <usersFilterContext.Provider value={{ filters, setFilters }}>
            {children}
        </usersFilterContext.Provider>
    )
}

export default UsersFilterProvider